import { useDispatch } from "react-redux"
import { Creators } from "model/apiWrapper"
import useResource from "hooks/resources"
import { useAccountAlias } from "resources/account"
import { useMutation } from "@tanstack/react-query"
import { Creators as modelCreators } from "model/data"
import { useResourcesList } from "resources/resource"

const RESOURCE_TYPE = "template"
const BASE_COLLECTIONS_TO_RESET = [`resourcesList-${RESOURCE_TYPE}`]

function getCollectionsToResetForTemplate(templateId) {
  if (!templateId) return BASE_COLLECTIONS_TO_RESET
  return [...BASE_COLLECTIONS_TO_RESET, `templateMetadata.${templateId}`]
}

export function useTemplates() {
  return useResourcesList(RESOURCE_TYPE)
}

export function useTemplateMetadata(templateId) {
  const account = useAccountAlias()

  return useResource({
    resource: `templateMetadata.${templateId}`,
    id: `templateMetadata.${templateId}`,
    url: () => account && templateId ? `/api/${account}/templates/${templateId}` : null,
  })
}

export function useSaveTemplate() {
  const account = useAccountAlias()
  const dispatch = useDispatch()

  const mutation = useMutation({
    mutationFn: (template) => {
      const payload = {
        name: template.name,
        config: { metrics: template.metrics },
      }

      return new Promise((resolve, reject) => {
        if (template.id) {
          dispatch(Creators.put(`/api/${account}/templates/${template.id}`, payload, resolve, reject))
        } else {
          dispatch(Creators.post(`/api/${account}/templates`, payload, resolve, reject))
        }
      })
    },
    onSuccess: (data, template) => {
      const templateId = data?.id ?? template?.id
      dispatch(modelCreators.resetCollections(getCollectionsToResetForTemplate(templateId)))
    },
  })

  return mutation.mutateAsync
}

export function useDeleteTemplate() {
  const account = useAccountAlias()
  const dispatch = useDispatch()

  const mutation = useMutation({
    mutationFn: (deletedTemplate) => {
      return new Promise((resolve, reject) => {
        dispatch(Creators.delete(`/api/${account}/templates/${deletedTemplate.id}`, undefined, resolve, reject))
      })
    },
    onSuccess: (_data, deletedTemplate) => {
      const templateId = deletedTemplate?.id ?? deletedTemplate
      dispatch(modelCreators.resetCollections(getCollectionsToResetForTemplate(templateId)))
    },
  })

  return mutation.mutateAsync
}
